import React from 'react'
import { Divider, withStyles } from '@material-ui/core'

const divider = () => <Divider light />

const styles = theme => ({})

export default withStyles(styles)(divider)
